import { t } from "i18next";
import { Button, Col, Row } from "react-bootstrap";

const SurveyCancelConfirmationModal = ({onClose, onConfirm}) =>{

    const onConfirmAndClose = () =>{
        onConfirm();
        onClose();
    }
    return (
        <>
        <Row>
        <Col lg="12" className='mb-3'>
        {t('generel.lebel.cancel.confirmation')}
         
        </Col>
        <Col lg="12" className='text-end'>
          <Button variant="outline-dark" className='ms-2' onClick={onClose}>{t('general.button.no.label')}</Button>
          <Button variant="primary" className='ms-2' onClick={onConfirmAndClose}>{t('general.button.yes.label')}</Button>
        </Col>

      </Row>
        </>
    )

}

export default SurveyCancelConfirmationModal;